import { useState } from "react";

type MgpAlertProps  = {
    type: "success" | "danger" | "info" | "warning";
    message: string;
    hasCloseBtn?: boolean;

}

export default function MgpMessage({type, message, hasCloseBtn}: MgpAlertProps) {
    const [hideMessage, setHideMessage] = useState(false);
    if(hideMessage) {
        return <></>;
    }
    return (
        <div className={"message " + type}>
            {message}
            {hasCloseBtn&&<span className="closebtn" onClick={() => {setHideMessage(true);}}>&times;</span>}
        </div>
    );
} 